// `fetch` rejects with a TypeError when no response arrives (offline, DNS,
// dropped connection, a laptop waking up). Each browser words it differently.
const NETWORK_ERROR_MESSAGE =
  /failed to fetch|networkerror when attempting to fetch|load failed|network request failed/i;

export function isNetworkError(error: unknown): boolean {
  return (
    error instanceof TypeError && NETWORK_ERROR_MESSAGE.test(error.message)
  );
}

export type ContextErrorKind = "network" | "auth" | "unknown";

export function getContextErrorKind(error: unknown): ContextErrorKind {
  if (isNetworkError(error)) {
    return "network";
  }
  // Both the dashboard HttpError and the ui-kit coordinator error carry `status`.
  // Only 401 means the session is gone. A 403 is a valid credential denied the
  // operation (ADR-0009), so signing the user out would not help.
  if (error instanceof Error && "status" in error && error.status === 401) {
    return "auth";
  }
  return "unknown";
}
